import React from 'react';

import { DashOutlined, DeleteOutlined, EditOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import stringres from '../../translations/stringres';

export default function MenuAddEdit(props) {
    const { onModifica } = props;
    const { onCancella } = props;
    const { onSelectRow } = props;
    const { onAllega } = props;

    const items = [
        {
            key: '1',
            label: (
                <Button icon={<EditOutlined />} style={{ border: '0px' }} onClick={onModifica}>
                    {stringres.t('modifica')}
                </Button>
            ),
        },
        {
            key: '2',
            label: (
                <Button icon={<DeleteOutlined />} style={{ border: '0px' }} onClick={onCancella}>
                    {stringres.t('elimina')}
                </Button>
            ),
        },
        props.attivaAllegato
            ? {
                  key: '3',
                  label: (
                      <Button icon={<PaperClipOutlined />} style={{ border: '0px' }} onClick={onAllega}>
                          {stringres.t('allegata')}
                      </Button>
                  ),
              }
            : null,
    ];

    return (
        <Dropdown trigger={['click']} menu={{ items }} placement="topLeft" arrow onClick={onSelectRow}>
            <Button icon={<DashOutlined />}></Button>
        </Dropdown>
    );
}
